var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2A35",
    d: "M23.38 6.701a2.715 2.715 0 0 0-1.915-1.915C19.775 4.333 13 4.333 13 4.333s-6.775 0-8.465.453A2.715 2.715 0 0 0 2.62 6.701C2.167 8.391 2.167 13 2.167 13s0 4.608.453 6.299c.249.931.983 1.666 1.915 1.915 1.69.453 8.465.453 8.465.453s6.775 0 8.465-.453a2.713 2.713 0 0 0 1.916-1.915c.452-1.69.452-6.299.452-6.299s0-4.609-.452-6.299ZM10.834 16.753V9.247l6.5 3.753-6.5 3.753Z",
    opacity: 0.4
  })));
};
export default SvgYoutube;